import React, { useEffect, useState } from "react";
import ContentLoadingBOS from "components/ContentLoadingBos";
import { useAssureBosSessionFromUrl, closeSession, leaveSession } from "components/BosSessionFromUrl";

// DevExtreme components
import notify from 'devextreme/ui/notify';

// Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as dataSegmentActions from "redux/actions/dataSegmentActions";
import * as sessionActions from "redux/actions/sessionActions";
import * as appStateActions from "redux/actions/appStateActions";
import ErrorMessageView from "../ErrorMessageView";

function SessionContainer(props) {
  const { currentUILanguageCode, uri, isPersistant, sessionClosed } = props;

  const [isLoading, setIsLoading] = useState(true);

  const { session, dataSegment, userError, connectionError } = useAssureBosSessionFromUrl(uri, isPersistant, currentUILanguageCode);

  useEffect(() => {
    setIsLoading(true);

    if (userError) {
      notify(userError, "error", 3000);
    }
    if (connectionError) {
      setIsLoading(false);
    }
    if (session) {
      if (isPersistant) {
        console.log("Setting Current Session", session);
        props.sessionActions.setCurrentSession(session.id);
      }
      setIsLoading(false);
    }

    return () => {
      if (dataSegment && session) {
        if (isPersistant)
          leaveSession(dataSegment.authToken, session);
        else
          closeSession(props.sessionActions, dataSegment.authToken, session);
      }
    }
  }, [session, userError, connectionError]);


  const handleCloseSession = () => {
    if (dataSegment && session) {
      closeSession(props.sessionActions, dataSegment.authToken, session);
      sessionClosed(session);
    }
  };

  const handleUpdateViewports = (viewports) => {
    props.sessionActions.updateSessionViewports(session.id, viewports);
  };

  return (isLoading
    ? <ContentLoadingBOS />
    : (connectionError
      ? <ErrorMessageView />
      : React.cloneElement(props.children, { session: session, dataSegment: dataSegment, onCloseSession: handleCloseSession, updateViewportList: handleUpdateViewports, ...props })
    )
  );
}

function mapStateToProps(state, ownProps) {
  return {
    currentUILanguageCode: state.appState.uiLanguageIsoCode,
    currentDataViewLanguageCode: state.appState.dataViewLanguageIsoCode,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataSegmentActions: bindActionCreators(dataSegmentActions, dispatch),
    sessionActions: bindActionCreators(sessionActions, dispatch),
    appStateActions: bindActionCreators(appStateActions, dispatch)
  };
}

export default
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SessionContainer);
